function KpiCard({ label, value, variant = "primary" }) {
  return (
    <div className={`kpi-card ${variant}`}>
      <span>{label}</span>
      <h2>{value}</h2>
    </div>
  );
}

export default KpiCard;
